import { Radio, ShieldCheck, Network } from "lucide-react";
import { Reveal, SectionHead } from "./primitives";

const CARDS = [
  {
    tid: "infra-card-ftso",
    idx: "01",
    icon: Radio,
    title: "FTSO Data Provider",
    body: "Anchor and Fast Updates operating on the Flare mainnet.",
    status: "Operating — Mainnet",
    live: true,
  },
  {
    tid: "infra-card-validator",
    idx: "02",
    icon: ShieldCheck,
    title: "Flare Validators",
    body: "Operating on the Flare mainnet, participating in consensus.",
    status: "Operating — Mainnet",
    live: true,
  },
  {
    tid: "infra-card-fdc",
    idx: "03",
    icon: Network,
    title: "Flare Data Connector",
    body: "Operating node infrastructure supporting the Flare Data Connector.",
    status: "Operating — Mainnet",
    live: true,
  },
];

export default function Infrastructure() {
  return (
    <section className="section" id="infrastructure" data-testid="infrastructure-section">
      <div className="wrap">
        <SectionHead
          index="02"
          label="Infrastructure"
          title="What we operate."
          right={<span className="infra-count">3 components</span>}
        />
        <div className="cards">
          {CARDS.map((c, i) => (
            <Reveal key={c.tid} delay={i * 0.1}>
              <article className="card" data-testid={c.tid} style={{ height: "100%" }}>
                <div className="card-top">
                  <span className="card-idx">{c.idx}</span>
                  <span className="card-icon">
                    <c.icon size={20} strokeWidth={1.75} />
                  </span>
                </div>
                <h3>{c.title}</h3>
                <p>{c.body}</p>
                <span className={`pill ${c.live ? "pill-live" : "pill-planned"}`}>
                  <i aria-hidden="true" />
                  {c.status}
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
